module.exports = "https://static.cdns.space/qurangrowth-temp/img/p2.fc41eeb4.webp";